(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialized = new WeakSet();
  function initialize(scope) {
    const galleries = scope.matches?.('.product-gallery') ? [scope] : scope.querySelectorAll('.product-gallery');
    galleries.forEach(gallery => {
      if (initialized.has(gallery)) return;
      initialized.add(gallery);
      const image = gallery.querySelector('.product-image img');
      const thumbs = Array.from(gallery.querySelectorAll('[data-image]'));
      if (!image || thumbs.length < 2) return;
      let index = Math.max(0, thumbs.findIndex(thumb => thumb.getAttribute('aria-pressed') === 'true'));
      const show = next => {
        index = (next + thumbs.length) % thumbs.length;
        const button = thumbs[index];
        image.srcset = button.dataset.imageSrcset || '';
        image.src = button.dataset.image;
        image.alt = button.dataset.alt || '';
        thumbs.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
        const strip = button.parentElement;
        const bounds = strip.getBoundingClientRect();
        const target = button.getBoundingClientRect();
        if (target.left < bounds.left) strip.scrollLeft += target.left - bounds.left;
        else if (target.right > bounds.right) strip.scrollLeft += target.right - bounds.right;
      };
      thumbs.forEach((thumb, position) => thumb.addEventListener('click', () => show(position)));
      gallery.querySelectorAll('[data-gallery-step]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => show(index + Number(button.dataset.galleryStep)));
      });
      gallery.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        show(index + (event.key === 'ArrowRight' ? 1 : -1));
      });
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  const variantSelect=document.querySelector('[data-variant-select]');const addButton=document.querySelector('[data-add]');const price=document.querySelector('[data-price]');const stock=document.querySelector('[data-stock]');if(variantSelect){variantSelect.addEventListener('change',()=>{const option=variantSelect.options[variantSelect.selectedIndex];const available=option.dataset.available==='true';price.textContent=option.dataset.price;addButton.disabled=!available;addButton.textContent=available?addButton.dataset.labelAdd:addButton.dataset.labelSoldOut;if(stock)stock.textContent=option.dataset.stockLabel})}
(() => {
  const initialized = new WeakSet();
  function initialize(scope) {
    const panels = scope.matches?.('.product-panel') ? [scope] : scope.querySelectorAll('.product-panel');
    panels.forEach(panel => {
      if (initialized.has(panel)) return;
      initialized.add(panel);
      let frame = 0;
      const observed = new WeakSet();
      const isVisible = element => {
        if (!element.isConnected || element.closest('[hidden], [aria-hidden="true"]')) return false;
        for (let parent = element; parent && parent !== panel.parentElement; parent = parent.parentElement) {
          const style = getComputedStyle(parent);
          if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse') return false;
        }
        return Array.from(element.getClientRects()).some(rect => rect.width > 0 && rect.height > 0);
      };
      const refresh = () => {
        frame = 0;
        if (!panel.isConnected) {
          mutationObserver.disconnect();
          resizeObserver?.disconnect();
          return;
        }
        const bundles = Array.from(panel.querySelectorAll('kaching-bundles-block'));
        bundles.forEach(bundle => {
          if (!observed.has(bundle)) {
            observed.add(bundle);
            resizeObserver?.observe(bundle);
          }
        });
        const active = bundles.some(bundle => {
          if (isVisible(bundle)) return true;
          return getComputedStyle(bundle).display === 'contents' &&
            Array.from(bundle.querySelectorAll('button, select, input, [role="radio"]')).some(isVisible);
        });
        if (panel.hasAttribute('data-bundle-active') !== active) panel.toggleAttribute('data-bundle-active', active);
      };
      const schedule = () => {
        if (!frame) frame = requestAnimationFrame(refresh);
      };
      const mutationObserver = new MutationObserver(schedule);
      const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
      mutationObserver.observe(panel, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'aria-hidden'] });
      window.addEventListener('resize', schedule);
      refresh();
    });
  }
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-header"]) return;
  try {
    
  const menuButton=document.querySelector('.menu');const mobileNav=document.querySelector('.mobile-nav');if(menuButton&&mobileNav){menuButton.addEventListener('click',()=>{const isOpen=mobileNav.classList.toggle('open');menuButton.setAttribute('aria-expanded',String(isOpen));document.body.classList.toggle('menu-open',isOpen)});mobileNav.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>{mobileNav.classList.remove('open');menuButton.setAttribute('aria-expanded','false');document.body.classList.remove('menu-open')}));}

  } catch(e) { console.error(e); }
})();
})();
